import CumulativeGradePolicy from 'bundles/authoring-grading-formula/models/GradePolicy/CumulativeGradePolicy';
import MasteryGradePolicy from 'bundles/authoring-grading-formula/models/GradePolicy/MasteryGradePolicy';
import { GradePolicy } from 'bundles/ondemand/constants/Constants';

type Policy = {
  passingThreshold?: number;
  trackPassingThresholds?: {};
};

// @ts-expect-error ts-migrate(2503) FIXME: Cannot find namespace 'GradePolicy'.
export default (obj: Record<GradePolicy.CUMULATIVE | GradePolicy.MASTERY, Policy>) => {
  if (obj[GradePolicy.MASTERY]) {
    return new MasteryGradePolicy();
  } else if (obj[GradePolicy.CUMULATIVE]) {
    const gradePolicy = obj[GradePolicy.CUMULATIVE];
    // @ts-expect-error TS18048 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
    return new CumulativeGradePolicy(gradePolicy.passingThreshold);
  } else {
    throw new Error('Unsupported Grade Policy');
  }
};
